import { defineMessage } from '../../../../services/localization';

export const messages = {
    buttonPreviousTitle: defineMessage('previous_document'),
    buttonNextTitle: defineMessage('next_document'),
    paginationText: defineMessage('currentindex_of_total'),
};
